export enum BillingStatus {
  Unsubmitted = 1,
  ClaimSubmitted = 2,
  ClaimResubmitted = 5,
  NotBilledNoTests = 10,
  NotBilledDemo = 11,
  NotBilledOther = 12,
}
